export default "__VITE_ASSET__ohLeV71n__"